import { render, staticRenderFns } from "./GoodsOrder.vue?vue&type=template&id=0c97cd08&scoped=true"
import script from "./GoodsOrder.vue?vue&type=script&lang=ts"
export * from "./GoodsOrder.vue?vue&type=script&lang=ts"
import style0 from "./GoodsOrder.vue?vue&type=style&index=0&id=0c97cd08&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c97cd08",
  null
  
)

export default component.exports